import *
    as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Form, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as AddUsrModels from '../../models/AdditionalUser';
import * as AddUsrStore from '../../store/AdditionalUser';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us';
import { SessionModel } from '../../models/SessionModel';
const Cleave = require('../../../node_modules/cleave.js/react');
//import Cleave from 'cleave.js';



type MyProps =
    { AdditionalUser: AddUsrModels.AdditionalUser, SessionState: SessionModel } & typeof AddUsrStore.actionCreators;

const AdditionalUserEntry: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const history= useHistory();

    const location = useLocation();

    //var requestState: { ServiceType: string } = { ServiceType: '' };
    //requestState = location.state;   

    useEffect(() => {
        if (props.AdditionalUser.success == 'Y') {            
            history.replace('Add-User');                        
            props.resetState();
        }
        if (props.AdditionalUser.error) {
            alert(props.AdditionalUser.error);
        }
    }, [props]);

    //useEffect(() => {
    //    if (!props.InitialData.loaded) {
    //        props.loadInitialData();
    //    }
    //}, []);

    const [NewUserRequestLocal, updateCustomerRequestInfo] = useState<AddUsrModels.AdditionalUser>({ ...AddUsrModels.initialState });

    const SubmitEvent = (e: React.FormEvent) => {
        console.log(NewUserRequestLocal);
        e.preventDefault();
        props.createUser(NewUserRequestLocal);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateCustomerRequestInfo({ ...NewUserRequestLocal, ...valueChanged });
    }
  
    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateCustomerRequestInfo({ ...NewUserRequestLocal, ...valueChanged });

    }

    const RequestBtn = () => {
        if (!props.AdditionalUser.processing) {
            return (<input type="submit" value="Submit" className="btn btn-success" id="RequestBtn" name="RequestBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.AdditionalUser.processing} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address } />
            {<Form onSubmit={SubmitEvent}>
                <Card className="additionaluser-card">
                    <CardHeader className="center-align">
                        {props.SessionState.SelectedSM.address.line1}
                     </CardHeader>
                    <CardBody>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Label"} />
                                <input type="text" required onChange={handleChange} className="form-control" key="phoneLabel" id="phoneLabel" name="phoneLabel" value={NewUserRequestLocal.phoneLabel} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Phone #"} />                                
                                <Cleave
                                    required
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="contactPhone" id="phoneNumber" name="phoneNumber"
                                    value={NewUserRequestLocal.phoneNumber}
                                />
                            </Col>
                        </Row>                                                                        
                    </CardBody>
                </Card>              
                <Card className='customer_request-btn-card'>
                    <CardBody>                        
                        <RequestBtn />
                    </CardBody>
                </Card>
                </Form>
            }
        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{
        AdditionalUser: state.additionalUserState,
        SessionState: state.sessionState 
    }
}),
    { ...AddUsrStore.actionCreators })(AdditionalUserEntry as any);